import { render, staticRenderFns } from "./AssessmentExpiredModal.vue?vue&type=template&id=2642603f&scoped=true&"
import script from "./AssessmentExpiredModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentExpiredModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentExpiredModal.vue?vue&type=style&index=0&id=2642603f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642603f",
  null
  
)

export default component.exports